import ajax from './ajax';

export default function () {
    const apiEndpointBase = `/api/v3/get_by_kind`;

    return ajax(apiEndpointBase, {
        method: 'GET',
        data: { kind: 'photogallery' }
    });
}
